import axios from 'axios'
import { errortoast, successtoast } from '../helper/helper';
let baseurl = "https://portfoliobackend2025.onrender.com/api";

class apicall {
  async contactApi(contact) {
    let result = await axios.post(`${baseurl}/contact`, contact);

    if (result.data.status === true) {
      successtoast(result.data.msg);
      return true;
    } else {
      errortoast(result.data.msg);
      return false;
    }
  }
}

export const { contactApi } = new apicall();